import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { RequestOptions, Headers } from '@angular/http';

@Injectable()
    export class ProductSearchService {
        endPoint: string;
        constructor(private http: Http) {
            this.endPoint = "http://localhost:52386/api/Client/GetClientList/term";
        }
        search(term: string): Observable<any[]> {
            // var ClientList = this.http.get(this.endPoint + '?term=' + term)
            //     .map((r: Response) => { return (r.json().length != 0 ? r.json() :
            //       [{ "ClientId": 0, "ClientName": "No Record Found" }]) as any[] });
            // return ClientList;
    
          var ClientList = this.http.get('assets/products.json')
            .map((r: Response) =>  {  var json = r.json();
                                      var list = json.response.searched_data;
                                          return list.filter(cl => this.isMatched(cl, term));
    
                                    });
    
    
          return ClientList;
        }
    
        isMatched(cl: any, term: string) {
            var descr:string = cl.matched_db_col;
          if (descr.toLowerCase().includes(term)) {
            return true;
          } else {
            return false;
          }
        }
    }
    


// WEBPACK FOOTER //
// ./src/app/commonnavbar/productsearch.ts